// extracted by mini-css-extract-plugin
export default {"root":"BannerTop-module-root","buttonClose":"BannerTop-module-buttonClose"};